import { ButtonHTMLAttributes, forwardRef } from 'react'
import { LucideIcon, Loader2 } from 'lucide-react'

export interface ActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  loading?: boolean
  icon?: LucideIcon
  iconPosition?: 'left' | 'right'
}

const iconSizes = {
  sm: 14,
  md: 16,
  lg: 20,
}

export const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  (
    {
      variant = 'primary',
      size = 'md',
      loading = false,
      icon: Icon,
      iconPosition = 'left',
      className = '',
      disabled,
      children,
      ...props
    },
    ref
  ) => {
    const isDisabled = disabled || loading
    const iconSize = iconSizes[size]

    return (
      <button
        ref={ref}
        className={`
          action-button
          action-button--${variant}
          action-button--${size}
          ${loading ? 'action-button--loading' : ''}
          ${className}
        `.trim().replace(/\s+/g, ' ')}
        disabled={isDisabled}
        {...props}
      >
        {loading ? (
          <>
            <Loader2 size={iconSize} className="action-button__spinner" />
            <span>{children}</span>
          </>
        ) : (
          <>
            {Icon && iconPosition === 'left' && <Icon size={iconSize} />}
            {children && <span>{children}</span>}
            {Icon && iconPosition === 'right' && <Icon size={iconSize} />}
          </>
        )}
      </button>
    )
  }
)

ActionButton.displayName = 'ActionButton'
